import { CardHeader, type CardHeaderProps } from "#ui/card";
import { Icon } from "#ui/icon";
import type { IconName } from "#ui/icon.names";
import { H2, Span } from "#ui/typography";

export interface CardHeaderWithIconTitleProps extends Omit<
  CardHeaderProps,
  "children"
> {
  iconName: IconName;
  title: string;
}

export function CardHeaderWithIconTitle({
  iconName,
  title,
  ...props
}: CardHeaderWithIconTitleProps) {
  return (
    <CardHeader palette="gray" {...props}>
      <H2 size="h6" className="space-x-8px">
        <Span>
          <Icon name={iconName} size="baird-md" inline />
        </Span>
        <Span>{title}</Span>
      </H2>
    </CardHeader>
  );
}
